import { render, staticRenderFns } from "./ConceptsTreeSkeletonLoader.vue?vue&type=template&id=10a34625"
import script from "./ConceptsTreeSkeletonLoader.vue?vue&type=script&lang=js"
export * from "./ConceptsTreeSkeletonLoader.vue?vue&type=script&lang=js"
import style0 from "./ConceptsTreeSkeletonLoader.vue?vue&type=style&index=0&id=10a34625&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/.pnpm/vuetify-loader@1.7.3_uhb5aaqqgawn4pxsnzso5z623i/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
